
<template>
  <div class="custom-12" @click="onlineJia = true" :style="{backgroundColor: bgColor,color: color}">
    <div class="info-content">
      <div class="left">
        <div class="left-img">
          <img src="../../static/IM/im-12.png" alt="" />
        </div>
        <div class="left-content">
          <div class="title">{{ data.title }}</div>
          <div class="descript">{{ data.missionType }}</div>
          <div class="descript">宣传患教</div>
          <div class="look-btn">立即查看</div>
        </div>
      </div>
    </div>
    <el-dialog title="健康宣教" append-to-body width="700px" :visible.sync="onlineJia" custom-class="set-health-article"
      center>
      <div class="phone-container" style="width:100%;height:620px">
        <iframe :src="data.url" scrolling="no" style="width:100%;height:100%" frameborder="0"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    bgColor: {
      type: String,
      default: "#F5F5F5"
    },
    color: {
      type: String,
      default: "#333"
    }
  },
  data() {
    return {
      onlineJia: false,
      paramData: {}
    };
  }
};
</script> 
<style scoped lang="less">
.descript {
  margin-top: 5px;
}
/deep/.el-dialog {
  width: fit-content;
}
.custom-12 {
  border-radius: 4px;
  width: 350px;
  border-radius: 4px;
  cursor: pointer;
  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left-img {
        margin-right: 15px;
        img {
          width: 60px;
          height: 60px;
        }
      }
      .left-content {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .title {
          font-size: 12px;
          font-weight: 600;
          color: #333;
        }
      }
    }
    .look-btn {
      color: #d38912;
      line-height: 27px;
      font-weight: bold;
    }
  }
}
</style>